<mat-vertical-stepper [linear]="isLinear" #stepper>
  <mat-step *ngIf="action != 'update'">
    <div class="card" style="padding:20px;border: 1px solid lightgrey;">
      <ng-template matStepLabel>Booth Type</ng-template>
      <form [formGroup]="booth_register_form">
        <div class="row">
          <div class="col">
            <div class="form-group" style="width:40%">
              <label>Booth Type <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
              <select class="form-control dropdown_box" formControlName='business_type_id' (ngModelChange)="onChange($event)">
                <option *ngFor="let booth_type of booth_types" [value]="booth_type['id']">{{booth_type['name']}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </form>
      <div *ngIf="display_product_prices">
        <div class="row">
          <div class="col-6" style="font-weight: bold;">
            Product name
          </div>
          <div class="col-6" style="font-weight: bold;">
            Discounted Price
          </div>
        </div>
        <span *ngIf="product_price != null">


        <div class="row" *ngFor="let product of products" style="margin-top: 10px;">
          <div class="col-6">
            {{ product['name'] }} - <span style="color: grey;">{{ product['mrp']}} Rs </span>
          </div>
          <div class="col-2">
            <input type="number" style="border: 1px solid lightgrey; border-radius: 6px;" [(ngModel)]="product_price[product.id]">
          </div>
        </div>
      </span>
      </div>
      <div *ngIf="booth_register_form.value.business_type_id != null">
        <button mat-button matStepperNext (click)="displayProducts()" class="next_color">Next</button>
      </div>
    </div>
  </mat-step>
  <mat-step *ngIf="booth_register_form.value.business_type_id != null">
    <div class="card" style="padding:20px;border: 1px solid lightgrey;">
      <ng-template matStepLabel>Enter Booth Code</ng-template>
      <form [formGroup]="booth_register_form">
        <div class="row">
          <div class="col-4">
            <label>Booth Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" style="font-weight: 500;" formControlName='code'>
          </div>
          <!-- *ngIf="!code_generated" -->
          <div class="col-4" >
            <button mat-raised-button (click)="checkCode()" style="color:green">Check</button>
          </div>
          <div class="col-4" *ngIf="code_generated">
            <i class="material-icons" style="color: green;">done_all</i>
          </div>
        </div>
        <div style="color:red" *ngIf="showError">
          Already Exists !
        </div>
        <div style="margin-top: 10px;">
          <button mat-button matStepperPrevious class="back_color">Back</button>
          <button mat-button matStepperNext class="next_color" style="margin-left: 15px;"
            *ngIf="code_generated">Next</button>
        </div>
      </form>
    </div>
  </mat-step>
  <mat-step>
    <div class="card" style="padding:20px;border: 1px solid lightgrey;">
      <ng-template matStepLabel>Booth Name</ng-template>
      <form [formGroup]="booth_register_form">
        <div class="row">
          <div class="col-4">
            <label>Booth Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='name'>
          </div>
        </div>
      </form>
      <div class="row" style="margin-top: 10px;">
        <div class="col-2">
          <button mat-button matStepperPrevious class="back_color">Back</button>
        </div>
        <div class="col-2">
          <button mat-button matStepperNext class="next_color"
            [disabled]="!booth_register_form.controls.name.valid">Next</button>
        </div>
      </div>
    </div>
  </mat-step>

  <mat-step>
    <div class="card" style="padding:20px;border: 1px solid lightgrey;">
      <ng-template matStepLabel>Booth details</ng-template>
      <form [formGroup]="booth_register_form">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Zone <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
              <select class="form-control dropdown_box" formControlName='zone_id'>
                <option *ngFor="let zone of zones" [value]="zone['id']">{{zone['name']}} </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Constituency <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <select class="form-control dropdown_box" formControlName='constituency_id'>
                <option *ngFor="let Constituency of constituencies" [value]="Constituency['id']">
                  {{Constituency['name']}}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Ward <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <select class="form-control dropdown_box" formControlName='ward_id'>
                <option *ngFor="let ward of wards[booth_register_form.value.constituency_id]" [value]="ward['id']">
                  {{ward['name']}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">address <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <textarea class="form-control" rows="3" formControlName='address' style="border-radius: 11px; text-indent: 14px;"></textarea>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Landmark </label>
              <textarea class="form-control" rows="3" formControlName='landmark'
                style="border-radius: 11px;"></textarea>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Location Category <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <select class="form-control dropdown_box" formControlName='location_category_id'>
                <option *ngFor="let location_category of location_categories" [value]="location_category['id']">
                  {{location_category['name']}} </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label style="white-space: nowrap;">Panchayat/Corporation Name<i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="text" class="form-control code_box" formControlName='location_category_value'>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Pincode <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
              <input type="number" class="form-control code_box" formControlName='pincode'>
            </div>
            <div style="font-style: italic; font-size: small; color: red"
              *ngIf="booth_register_form.controls.pincode.errors !== null">
              {{ booth_register_form.controls.pincode.errors['error']}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-check">
              <label class="form-check-label" for="exampleRadios1" style="margin-left: -19px;">
                Select the Area Type <i class="material-icons" style="color: red;font-size: 14px;">star</i>
              </label>
              <mat-radio-group formControlName='is_rural' aria-label="Select an option">
                <mat-radio-button value=true>Rural</mat-radio-button>
                <mat-radio-button value=false>Urban</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>

      </form>
      <div class="row" style="margin-top: 16px;">
        <div class="col-2">
          <button mat-button matStepperPrevious class="back_color">Back</button>
        </div>
        <div class="col-2">
          <!-- <button mat-button matStepperNext class="next_color"
            [disabled]="activateBoothDetail()">Next</button> -->
        <button mat-raised-button color="primary" (click)="registerBooth()" [disabled]="!booth_register_form.valid"
        style="text-transform: capitalize">{{action}}  <mat-icon *ngIf="register_on_process"><mat-spinner color="accent" diameter="20">
        </mat-spinner></mat-icon></button>
      </div>
      </div>
    </div>
  </mat-step>
  <!-- <mat-step>
    <div class="card" style="padding:20px;border: 1px solid lightgrey;">
      <ng-template matStepLabel>Booth Timings</ng-template>
      <form [formGroup]="booth_register_form">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Working Hours From <span style="color:grey">(24 hours format)</span> <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>

              <input type="time" class="form-control time_select" formControlName='working_hours_from'>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Working Hours To <span style="color:grey">(24 hours format)</span> <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="time" class="form-control time_select" formControlName='working_hours_to'>
            </div>
          </div>
        </div>
        <button mat-raised-button color="primary" (click)="registerBooth()" [disabled]="!booth_register_form.valid"
          style="text-transform: capitalize">{{action}}  <mat-icon *ngIf="register_on_process"><mat-spinner color="accent" diameter="20">
          </mat-spinner></mat-icon></button>
      </form>
    </div>
  </mat-step> -->
</mat-vertical-stepper>
